import React from 'react';
import ElementDataRow from 'components/common/element-data/ElementDataRow';
import { ElementMetadataFieldName, IElementDataDataSource } from 'components/common/element-data/types';
import ElementDataRowLabel from 'components/common/element-data/ElementDataRowLabel';
import ElementDataRowValue from 'components/common/element-data/ElementDataRowValue';
import useBundleTranslation from 'i18n';
import { getFieldElementMetadataSettings } from 'components/common/element-data/functions';

export default function DataSource(props: IElementDataDataSource) {
    const { t } = useBundleTranslation(['components/common/element_data']);
    const { dataSourceName = '', settings } = props;
    const fieldKey: ElementMetadataFieldName = 'data_source';
    const { fieldMetadataDisplay, fieldMetadataOrder } = getFieldElementMetadataSettings(settings, fieldKey);

    if (!fieldMetadataDisplay || !dataSourceName) return null;

    return (
        <ElementDataRow order={fieldMetadataOrder}>
            <ElementDataRowLabel>{t(`element_data_label.${fieldKey}`)}</ElementDataRowLabel>
            <ElementDataRowValue>{dataSourceName}</ElementDataRowValue>
        </ElementDataRow>
    );
}
